import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Studio } from './shell/index.js';
import './shell/styles.css';

const root = document.getElementById('root');
if (root === null) throw new Error('Missing #root');
createRoot(root).render(
  <StrictMode>
    <Studio />
  </StrictMode>,
);
